import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { TermsConditionsContent } from "./index";
import "./terms-modal.css";

/** Terms of Use in a dialog, so signup keeps the half-filled form behind it. */
export default function TermsConditionsModal({ open, onClose, onAccept }) {
  const bodyRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  useEffect(() => {
    if (open && bodyRef.current) bodyRef.current.scrollTop = 0;
  }, [open]);

  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div
      className="agcex-terms-overlay"
      role="presentation"
      onMouseDown={(e) => {
        if (e.button !== 0) return;
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="agcex-terms-modal" role="dialog" aria-modal="true" aria-labelledby="agcex-terms-modal-title">
        <div className="agcex-terms-modal__head">
          <h2 id="agcex-terms-modal-title" className="agcex-terms-modal__title">
            Terms of Use
          </h2>
          <button type="button" className="agcex-terms-modal__close" aria-label="Close terms of use" onClick={onClose}>
            <i className="ri-close-line" aria-hidden="true" />
          </button>
        </div>

        <div className="agcex-terms-modal__body" ref={bodyRef} tabIndex={-1}>
          <TermsConditionsContent showTitle={false} scrollContainerRef={bodyRef} />
        </div>

        <div className="agcex-terms-modal__foot">
          <button type="button" className="agcex-terms-modal__btn agcex-terms-modal__btn--ghost" onClick={onClose}>
            Close
          </button>
          {onAccept ? (
            <button type="button" className="agcex-terms-modal__btn" onClick={onAccept}>
              I Agree
            </button>
          ) : null}
        </div>
      </div>
    </div>,
    document.body
  );
}
